export const PLANS = {
  FREE_TOS: 'freeTos',
  FREE: 'free',
};
